import { render } from "./ReviewPosts.vue?vue&type=template&id=4d1cda7d&scoped=true"
import script from "./ReviewPosts.vue?vue&type=script&lang=js"
export * from "./ReviewPosts.vue?vue&type=script&lang=js"

import "./ReviewPosts.vue?vue&type=style&index=0&id=4d1cda7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1cda7d"]])

export default __exports__